//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Grid, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { theme } from '@react/components/theme'
import { erc20WeiToCommaDecString } from '@shared/conversions'

import { AddressPill } from '@react/components/addresses/AddressPill'
import { TableHeaderItem } from '@react/components/TableHeaderItem'
import { useOtDispatch } from '@react/redux/store'
import { acceptDynamicRedeemRequestTx } from '@react/signedTxs/acceptDynamicRedeemRequestTx'
import { DynamicWithdrawalActivityCTO } from '@shared/PoolEventCTO'

export default function BorrowerAcceptDynamicRedeemRequestForm(props: {
  activity: DynamicWithdrawalActivityCTO
  symbol: string
  liquidityTokenSymbol: string
}): ReactElement {
  const { activity, symbol, liquidityTokenSymbol } = props
  const dispatch = useOtDispatch()
  const { assets, shares, lender } = activity

  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    marginLeft: '8px',
    borderRadius: '6px',
  }

  const acceptEarlyRedeemRequestClick = (): void => {
    setIsSubmitted(true)
    dispatch(acceptDynamicRedeemRequestTx({ activity }))

    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }
  return (
    <div data-testid="ACCEPT_EARLY_REDEEM_FORM">
      <Typography variant="body" sx={{ marginTop: 10, marginBottom: 2 }}>
        Please accept the Early Withdrawal Request. Once accepted, loan collateral should be liquidated and the Early
        Withdrawal Amount set.
      </Typography>
      <Box>
        {' '}
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TableHeaderItem>Lender</TableHeaderItem>
            </Grid>
            <Grid item xs={4}>
              <TableHeaderItem>Request Amount</TableHeaderItem>
            </Grid>
            <Grid item xs={4}>
              <TableHeaderItem>Principal({symbol})</TableHeaderItem>
            </Grid>
          </Grid>

          <Grid container sx={{ marginBottom: 4 }}>
            <Grid item xs={4}>
              <Box sx={{ width: '75%' }}>
                <AddressPill addr={lender} />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ marginLeft: 1 }} variant="bodyBold">
                {erc20WeiToCommaDecString(shares)} {symbol}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ marginLeft: 1 }} variant="bodyBold">
                {erc20WeiToCommaDecString(assets)} {liquidityTokenSymbol}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Button
        disabled={isSubmitted}
        sx={sx}
        onClick={() => {
          acceptEarlyRedeemRequestClick()
        }}
        variant={'contained'}
      >
        <Typography variant={'buttonBold'}>Accept Early Withdraw Request</Typography>
      </Button>
    </div>
  )
}
